/* eslint-disable max-len */
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ManagePhotoColumn } from '.';

export interface ManagePhotoTableHeadProps {
  columns: ManagePhotoColumn[];
};

export const ManagePhotoTableHead = memo((props: ManagePhotoTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth, textAlign: col.align }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
});

ManagePhotoTableHead.displayName = 'ManagePhotoTableHead';
